/* eslint-disable */
import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import ko from 'knockout';
import state from '@bingads-webui-component-legacy/state/index';
import tmpl from '@bingads-webui-component-legacy/pagination/layout/simple.pug';
import KoModel from '@bingads-webui-component-legacy/pagination/viewmodel/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/pagination');
var Pagination = Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'p_click', 'n_click');
    this.options = _.defaults(options || ({}), {
      page_size: state.get('gridPageSize') || 20,
      template: tmpl,
      i18n: i18n
    });
    this.ko_model = new KoModel(this.options);
  },
  events: {
    'click .previous': 'p_click',
    'click .next': 'n_click',
    'change .pagination-size': 'sizeChanged',
    'change .pagination-number': 'numberChanged'
  },
  sizeChanged: function (e) {
    this.trigger('change:size', e, {
      page_size: this.ko_model.page_size()
    });
  },
  numberChanged: function (e) {
    this.trigger('change:number', e, {
      page_number: this.ko_model.page_number()
    });
  },
  p_click: function (e) {
    var isDisabled = $(e.currentTarget).hasClass('disabled');
    if (!isDisabled) {
      this.trigger('click:previous', e, {
        page_number: this.ko_model.page_number()
      });
    }
  },
  n_click: function (e) {
    var disabled = $(e.currentTarget).hasClass('disabled');
    if (!disabled) {
      this.trigger('click:next', e, {
        page_number: this.ko_model.page_number()
      });
    }
  },
  page: function (num) {
    this.ko_model.page_number(num);
  },
  render: function () {
    this.el.innerHTML = this.options.template({
      i18n: this.options.i18n
    });
    ko.applyBindings(this.ko_model, this.el);
    return this;
  }
});
export default Pagination;

